import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import Avatar from '@/components/avatar/Index.vue';
let WebviewBackgroundOverlay = class WebviewBackgroundOverlay extends mixins() {
    get headerImgPath() {
        return require('@/assets/images/mobile-layout-header.svg');
    }
};
__decorate([
    Prop({ type: String, required: false, default: 'Page Name' })
], WebviewBackgroundOverlay.prototype, "pageName", void 0);
__decorate([
    Prop({ type: String, required: false })
], WebviewBackgroundOverlay.prototype, "pagePhotoUrl", void 0);
WebviewBackgroundOverlay = __decorate([
    Component({
        components: {
            Avatar,
        },
    })
], WebviewBackgroundOverlay);
export default WebviewBackgroundOverlay;
